import * as api from "../transport/api/artifact-api.js";
import * as store from "./stores/artifact-store.js";

export async function loadArtifacts(sessionId) {
  if (!sessionId) return store.clearArtifacts();
  store.beginLoad(sessionId);
  try {
    const artifacts = await api.listArtifacts({ sessionId });
    if (store.getArtifactState().sessionId !== sessionId) return;
    store.setArtifacts(sessionId, artifacts);
  } catch (error) {
    if (store.getArtifactState().sessionId !== sessionId) return;
    store.setError(sessionId, error);
  }
}

export async function updateArtifactLifecycle({ sessionId, artifactId, action }) {
  await api.updateArtifactLifecycle({ artifactId, action });
  await loadArtifacts(sessionId);
}

export { store as artifactStore };
